<template>
	<div class="upsizhu">
        <main>
            <div class="list">
                <h2>死猪上传</h2>

                <van-field v-model="tell" label="电话"  />
                <van-field v-model="name" label="姓名"  />

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="zhuchang"
                    label="猪场"
                    placeholder="点击选择"
                    @click="showPicker2 = true"
                />

                <van-popup v-model:show="showPicker2" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                    />
                </van-popup>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="gongsi"
                    label="公司"
                    placeholder="点击选择"
                    @click="showPicker3 = true"
                />

                <van-popup v-model:show="showPicker3" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns3"
                        @confirm="onConfirm3"
                        @cancel="showPicker3 = false"
                    />
                </van-popup>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="time"
                    label="死亡时间"
                    placeholder="点击选择"
                    @click="showPicker = true"
                />

                <van-popup v-model:show="showPicker" position="bottom">
                    <van-datetime-picker
                        :max-date="maxDate"
                        v-model="currentDate"
                        type="datetime"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                    />
                </van-popup>

                <van-field name="radio" label="猪只类型">
                    <template #input>
                        <van-radio-group v-model="leixing" direction="horizontal">
                            <van-radio checked-color="#ee0a24" name="保育猪">保育猪</van-radio>
                            <van-radio checked-color="#ee0a24" name="育肥猪">育肥猪</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <van-field v-model="toushu" type="number" label="死亡头数"  />
                <van-field v-model="zhongliang" label="死亡重量(KG)"  />
                <van-field v-model="yuanyin" label="死亡原因"  />

                <van-field name="radio" label="是否申报保险">
                    <template #input>
                        <van-radio-group v-model="baoxian" direction="horizontal">
                            <van-radio checked-color="#ee0a24" name="是">是</van-radio>
                            <van-radio checked-color="#ee0a24" name="否">否</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <van-field v-model="beizhu" label="备注"  />

                <h4>死亡单、人跟猪一起、猪只死亡编号、无害化处理。</h4>·
                <van-uploader  v-model="fileList" multiple :max-count="5"  :before-read="beforeRead"/>
                <br><br>
                <br><br>
                <van-button type="danger" style="width:100%" @click="sub()">提交</van-button>

            </div>
        </main>
    </div>
</template>

<script>
    import { url2 } from '../router/api';
    import options from "../config/option.js"

	export default{
		data(){
			return{
                tell:'',
                name:'',
                gongsi:'',
                zhuchang:'',
                time:'',
                leixing:'保育猪',
                toushu:'',
                zhongliang:'',
                yuanyin:'',
                baoxian:'是',
                beizhu:'',

                columns2:options.sizhu,
                columns3:['浙江华服农业开发有限公司','浙江华宜开发农业有限公司'],

                fileList: [],
                loading:'',

                maxDate: new Date(2030, 10, 1),
                currentDate: new Date(),

                showPicker:false,
                showPicker2:false,
                showPicker3:false,
            }
        },

		methods: {
            onConfirm(value) {
                this.time = this.formatDate(value)
                this.showPicker = false;
            },

            formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                hh = hh < 10 ? '0' + hh : hh
                mm = mm < 10 ? '0' + mm : mm
                return `${y}-${m}-${d} ${hh}:${mm}`;
            },
            onConfirm2(value) {
                this.zhuchang = value;
                this.showPicker2 = false;
            },
            onConfirm3(value) {
                this.gongsi = value
                this.showPicker3 = false;
            },

            beforeRead(file){
               return this.$compress(file)
            },

            sub() {
                if(this.tell=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入电话',
                    }).then(() => {
                        return;
                    });
                } else if(this.name=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入姓名',
                    }).then(() => {
                        return;
                    });
                } else if(this.zhuchang=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入猪场',
                    }).then(() => {
                        return;
                    });
                } else if(this.gongsi=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入公司',
                    }).then(() => {
                        return;
                    });
                } else if(this.time=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入死亡时间',
                    }).then(() => {
                        return;
                    });
                } else if(this.toushu=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入死亡头数',
                    }).then(() => {
                        return;
                    });
                }  else if(this.zhongliang=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入死亡重量',
                    }).then(() => {
                        return;
                    });
                } else if(this.yuanyin=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入死亡原因',
                    }).then(() => {
                        return;
                    });
                } else if(this.fileList=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '是否确定提交',
                    }).then(() => {
                        this.sure()
                    }).catch(() => {});
                }
            },

            sure() {
                 if(this.fileList.length<4) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请最少上传四张照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: '加载中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formData =new FormData();
                    this.fileList.map(item=>{
                        formData.append('file[]',item.file);
                    })
                        this.axios.post(url2+'upload_sz',(formData),{
                            headers: {  'Content-Type': 'multipart/form-data;' }
                        }).then(res=> {
                            if(res.data.code==1) {
                                this.sure2(res.data.data)
                                // console.log(111)
                            }  else {
                                this.loading.close();
                            }
                        }).catch(err=> {
                            this.loading.close();
                            console.log(err);
                        });
                }
            },

            sure2(photo) {
                this.axios.get(url2+'sizhu', {
                    params:{
                        tell: this.tell,
                        name: this.name,
                        zhuchang: this.zhuchang,
                        gongsi: this.gongsi,
                        time: this.time,
                        leixing: this.leixing,
                        toushu: this.toushu,
                        zhongliang: this.zhongliang,
                        yuanyin:this.yuanyin,
                        baoxian:this.baoxian,
                        beizhu:this.beizhu,
                        url:photo.toString()
                    }
                }).then(res=> {
                    if(res.status==200) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.fileList = []
                            this.tell = ''
                            this.name = ''
                            this.zhuchang = ''
                            this.gongsi = ''          
                            this.time = ''
                            this.leixing = ''
                            this.toushu = ''
                            this.zhongliang = ''
                            this.yuanyin = ''
                            this.baoxian = ''
                            this.beizhu = ''
                        });
                    } else {
                        this.loading.close();
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .upsizhu main {
        font-size: 14px;
        padding: 40px 16px 60% 16px;
        background-color: #FFDCA3;
    }
    .upsizhu .list {
        background-color: #fff;
        padding: 20px;
        color: #EE0A24;
    }
    .upsizhu h2 {
        text-align: center;
        margin-bottom: 20px;
    }
   
    .upsizhu /deep/ .van-field__label {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 6.2em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        word-wrap: break-word;
    }
    .upsizhu h4 {
        text-indent: 16px;
    }
    .upsizhu /deep/ .van-uploader {
        position: relative;
        display: inline-block;
        margin-left: 16px;
    }
    .upsizhu[data-v-c2ee7228] /deep/ .van-field__label {
        flex: none;
        box-sizing: border-box;
        width: 6.8em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        word-wrap: break-word;
    }
</style>



